import {ISystemPermissionBase} from "@/types/models/ISystemPermission.ts";

/**
 * System Permission enumeration for use in access control
 */
export class SysPerm extends Object implements ISystemPermissionBase {
    module: string;
    name: string;

    constructor(spData: ISystemPermissionBase) {
        super()
        this.module = spData.module
        this.name = spData.name
    }

    static SYSTEM_PERMISSION_ADMIN = new SysPerm({"module": "System Permission", "name": "Admin"})
    static SYSTEM_PERMISSION_MANAGER = new SysPerm({"module": "System Permission", "name": "Manager"})
    static LINK_ADMIN = new SysPerm({"module": "Link", "name": "Admin"})
    static CALENDAR_CATEGORY_ADMIN = new SysPerm({"module": "Calendar", "name": "Category Admin"})
    static USER_MANAGE_STATUS = new SysPerm({"module": "User", "name": "Manage Status"})
    static DEV_VIEW_DEBUG = new SysPerm({"module": "Dev", "name": "View Debug"})
    static CONFIG_ADMIN = new SysPerm({"module": "Config", "name": "Admin"})
    static TEAM_ADMIN = new SysPerm({"module": "Team", "name": "Admin"})
    static SCORECARD_MEASURABLE_ADMIN = new SysPerm({"module": "Scorecard", "name": "Measurable Admin"})
    static SCORECARD_GLOBAL_MEASURABLE_EDITOR = new SysPerm({"module": "Scorecard", "name": "Global Measurable Editor"})
    static API_KEY_ADMIN = new SysPerm({"module": "API", "name": "Key Admin"})
    static USER_CREATE_LOCAL_USER = new SysPerm({"module": "User", "name": "Create Local User"})
    static DOORS_READ_DOOR_ACLS = new SysPerm({"module": "Doors", "name": "Read Door ACLs"})
    static DOORS_MODIFY_DOOR_ACLS = new SysPerm({"module": "Doors", "name": "Modify Door ACLs"})
    static USER_IMPORT_MICROSOFT_USER = new SysPerm({"module": "User", "name": "Import Microsoft User"})
    static ACCOUNTABILITY_CHART_ADMIN = new SysPerm({"module": "Accountability Chart", "name": "Admin"})
    static USER_IMPERSONATE_USER = new SysPerm({"module": "User", "name": "Impersonate"})
    static AUDIT_VIEW_LOGS = new SysPerm({"module": "Audit", "name": "View Logs"})
    static JOB_LOG_VIEW = new SysPerm({"module": "Job Log", "name": "View Logs"})
    static JOB_LOG_EDIT = new SysPerm({"module": "Job Log", "name": "Edit Jobs"})
    static PROJECT_ADMIN = new SysPerm({"module": "Project", "name": "Admin"})
    static USER_VIEW_RESTRICTED = new SysPerm({"module": "User", "name": "View Restricted"})
    static USER_MANAGE_DIRECTORY = new SysPerm({"module": "User", "name": "Manage Directory"})
    static USER_EXPORT_DIRECTORY = new SysPerm({"module": "User", "name": "Export Directory"})
    static BRAVOBITS_ITEM_ADMIN = new SysPerm({"module": "BravoBits", "name": "Item Admin"})
    static BRAVOBITS_BALANCE_ADMIN = new SysPerm({"module": "BravoBits", "name": "Balance Admin"})
    static BRAVOBITS_PROCESS_REDEMPTIONS = new SysPerm({"module": "BravoBits", "name": "Process Redemptions"})
    static BRAVOBITS_RECEIVE_CORE_VALUE_NOMINATION_EMAILS = new SysPerm({"module": "BravoBits", "name": "Receive Core Value Nomination Emails"})
    static CPM_ORDER_REPORT_VIEW = new SysPerm({"module": "CPM Order Report", "name": "View"})
    static CPM_ORDER_REPORT_ADD_NOTES = new SysPerm({"module": "CPM Order Report", "name": "Add Notes"})
    static CPM_ORDER_REPORT_TRIGGER = new SysPerm({"module": "CPM Order Report", "name": "Trigger"})
    static SHIPPING_REQUEST_SHIPPER = new SysPerm({"module": "Shipping Requests", "name": "Shipper"})
    static TIMECARD_USER = new SysPerm({"module": "Timecard", "name": "User"})
    static TIMECARD_TIMELESS_EDIT_ENABLED = new SysPerm({"module": "Timecard", "name": "Timeless Edit Enabled"})
    static TIMECARD_TIMESTAMPED_EDIT_ENABLED = new SysPerm({"module": "Timecard", "name": "Timestamped Edit Enabled"})
    static TIMECARD_MANAGER = new SysPerm({"module": "Timecard", "name": "Manager"})
    static TIMECARD_TIME_CLOCK_API_ADMIN = new SysPerm({"module": "Timecard", "name": "Time Clock API Admin"})
    static TIMECARD_ADMIN = new SysPerm({"module": "Timecard", "name": "Admin"})
    static PAYCHEX_SYNC = new SysPerm({"module": "Paychex", "name": "Run Sync"})
    static TIMECARD_VIEW_REPORTS = new SysPerm({"module": "Timecard", "name": "View Reports"})
    static OPENPROJECT_WORKFLOW_ADMIN = new SysPerm({"module": "OpenProject Workflow", "name": "Admin"})
    static CONTRACTOR_VIEW_COMPANYWIDE_INFO = new SysPerm({"module": "Contractor", "name": "View Companywide Info"})
    static HAPROXY_VIEW = new SysPerm({"module": "HAProxy", "name": "View"})
    static HAPROXY_MANAGE = new SysPerm({"module": "HAProxy", "name": "Manage"})
}